import { cn } from "@/lib/utils";
import { LogoIcon } from "@assets/icons";
import { Button } from "@components/ui/button";
import Dialog from "@ui/external/components/dialog";
import { getTableInfo } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import React from "react";
import { NavLink, useNavigate } from "react-router";
import BrandingForm from "../form/branding.form";
import { ChevronLeft } from "lucide-react";

const index: React.FC<any> = () => {
  const result = getTableInfo({
    mode: "default",
    type: "branding",
  });
  let { title = "", description = "" }: any = result;


  const { handleAction, searchParams } = useHandleAction({});

  return (
    <>
      <div className=" h-[70dvh] gap-10">
        <div className="flex justify-between items-center">
          {" "}
          <ul className="list-none">
            {<li className="text-[32px] font-[500]">{title}</li>}
            {<li className="text-[#7B7679] text-[14px]">{description}</li>}
          </ul>
          <Button
            onClick={() => {
              handleAction({
                type: "modal-add",
              });
            }}
          >
            Add Branding
          </Button>
        </div>
        <div className="flex flex-wrap gap-3 mt-10">
          <NavLink to={"logos?orientation=grid"}>
            <div className="bg-[#F3F3F3]  w-[315px] rounded-md h-[100px] px-20px py-18px flex gap-10 items-center">
              <LogoIcon />
              <h5 className="font-bold">Logos</h5>
            </div>
          </NavLink>
          <NavLink to={"signatures?orientation=grid"}>
            <div className="bg-[#F3F3F3]  w-[315px] rounded-md h-[100px] px-20px py-18px flex gap-10 items-center">
              <LogoIcon />
              <h5 className="font-bold">Signature</h5>
            </div>
          </NavLink>
          <NavLink to={"stamps?orientation=grid"}>
            <div className="bg-[#F3F3F3]  w-[315px] rounded-md h-[100px] px-20px py-18px flex gap-10 items-center">
              <LogoIcon />
              <h5 className="font-bold">Stamps</h5>
            </div>
          </NavLink>
        </div>
      </div>
      <Dialog
        className={cn([
          "bg-white shadow-none border-none",
          "min-w-[600px] max-h-[90vh]",
        ])}
        open={searchParams.get("modal") ? true : false}
        setOpen={() => {
          handleAction({
            type: searchParams.get("confirm") ? "confirm-close" : "modal-close",
          });
        }}
      >
        <div className="overflow-y-auto h-[500px]">
          <BrandingForm refetch={() => {}} />
        </div>
      </Dialog>
    </>
  );
};

export default index;
